<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div :class="{ 'blur-content': this.isLoading }">
      <div class="main-wrapper">
        <!--begin::sidebar-->
        <sidebar-component classMenu="TransportOrderCt"></sidebar-component>
        <!--end::sidebar-->

        <div class="page-wrapper">
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->

          <!--begin::content-->
          <div class="page-content">

            <div>
              <h4 style="margin-right: 5px" class="float-start"></h4>
              <h4 class="mb-12 mb-md-0">
                Question & Answer P2H
              </h4>
              <br />
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-lg-4">
                    
                      <!-- <date-range-picker style="width: 100%" control-container-class="form-control"
                        :locale-data="locale" v-model="dateFilter" :opens="opens" :singleDatePicker="false"
                        :timePicker24Hour="true" :timePicker="true" :showWeekNumbers="false">
                      </date-range-picker> -->


                    </div>

                    <div class="col-lg-2">
                      <!-- <v-select :options="fetchStatus" v-model="status" label="name" return-object></v-select> -->
                    </div>

                    <!-- <div class="col-lg-2">
                      <button class="btn btn-primary me-2 mb-2 mb-md-0 col-xs-12" @click="loadItems()">GO </button>
                      <span style="width:5px">{{ " " }}</span>

                    </div> -->


                    <div class="col-lg-4">




                      <button v-if="permision_role.method_custom1" class="btn btn-success float-end btn-xs"
                        style="margin-right: 5px" @click.prevent="newData()">
                        Create New
                      </button>
                    </div>




                  </div>


                </div>

                <div class="card-body">

                  <div class="table-responsive" style="overflow-y: auto;">
                    <div class="col-sm-12">

                      <vue-good-table title="list-order-ct" ref="list-order-ct" mode="remote" :select-options="{
                        enabled: selectOnCheckboxOnly,
                        selectOnCheckboxOnly: false,
                        selectionText: $t('data_selected'),
                        clearSelectionText: $t('clear'),
                      }" @on-selected-rows-change="selectionChanged" @on-page-change="onPageChange"
                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                        :isLoading.sync="isLoading" :pagination-options="{
                          enabled: true,
                        }" :rows="rows" :columns="columns">
                        <!-- <div slot="table-actions">
                {{ $t("no_select_data") }}
              </div> -->
                        <div slot="selected-row-actions">



                          <!-- <button class="btn btn-success btn-xs" style="margin-right:20px;" @click="approveModalApprove"
                  > <i class="mdi mdi-send-outline"></i>Approve</button>

                <button class="btn btn-danger btn-xs" @click="cancelOrder" ><i
                    class="mdi mdi-close"></i>Reject</button> -->
                        </div>



                        <template slot="table-row" slot-scope="props">


                          <span v-if="props.column.field == 'actions'">


                            <a style="color: #ab0635;text-decoration: none; cursor: pointer;"
                              v-if="permision_role.method_update" title="Edit " @click.prevent="
                                editData(props.row)
                                ">
                              <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>

                            </a>
                            <a style="color: #ab0635;text-decoration: none; cursor: pointer;"
                              v-if="permision_role.method_read" title="Reject" @click.prevent="
                                detailData(props.row)
                                ">
                              <i class="mdi mdi-eye" style="font-size:16px"></i>

                            </a>


                            <a style="color: #ab0635;text-decoration: none; cursor: pointer;"
                              v-if="permision_role.method_update" title="Copy " @click.prevent="
                                copyData(props.row)
                                ">
                              <i class="mdi mdi-content-copy" style="font-size:16px"></i>

                            </a>



                          </span>


                          <span v-else-if="props.column.field == 'payable'">
                            {{ formatNumber(props.row.payable) }}
                          </span>







                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>

                    </div>
                  </div>
                </div>

              </div>
            </div>



          </div>
          <!--end::content-->

          <!-- <modal-approve-data :showModal="showModalApprove" :action="actions" :data="datas"
            @closeModal="closeMyModal"></modal-approve-data> -->


          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import ModalApproveChecklistP2H from "@/components/modal/modalApproveChecklistP2H.vue";
//import Datepicker from "vuejs-datepicker";


import moment from 'moment';

export default {
  name: "DriverAttendance",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // "modal-approve-data": ModalApproveChecklistP2H,
    //Datepicker,
   
  },
  data() {
    const startDate = moment().subtract(1, 'day').format('YYYY-MM-DD'); // H-1
    const endDate = moment().add(1, 'day').format('YYYY-MM-DD'); // H+1

    return {
      datas: "",
      fetchStatus: [
        {
          name: 'Active',
        },
        {
          name: 'Not Active',
        }

      ],
      status: {
        name: ""
      },
      actions: "",
      showModalApprove: false,
      rowsSelection: [],
      transport_order_header_ids: [],
      selectOnCheckboxOnly: false,
      opens: "center",
      locale: {
        format: "yyyy-mm-dd",
      },
      showModalRecap: false,
      dataModal: {},
      maxToasts: 100,
      filtertanggal: new Date(),
      dateFilter: {
        startDate,
        endDate,
      },
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        // columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [

        {

          label: "Action",
          field: "actions",
          sortable: false,
        },




        {
          label: "Name",
          field: "p2h_name",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },




        {
          label: "Description",
          field: "p2h_description",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Deployment Date",
          field: "deployment_date",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: "Enabled",
          field: "enabled",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['yes','no'], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },












      ],
      rows: [],
    };
  },
  watch: {},
  computed: {
  },
  methods: {

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'ChecklistP2HController') {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_custom1) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      if (this.$route.query.msg) {
        if (this.$route.query.status == 200) {
          this.success(this.$route.query.msg)
        } else {
          this.error(this.$route.query.msg)
        }

      }

    },

    formatNumber(value) {
      //console.log(value);
      return parseInt(value).toLocaleString();
    },

    closeMyModal() {
      this.showModalApprove = false;
      this.loadItems();
    },

    approveModalApprove() {

      this.showModalApprove = true;
    },

    editData(row) {
      var params = this.$onRandom(row.m_p2h_question_id);
      this.$router.push(`ct-question-answer-p2h/create?action=edit&params=${params}`);
      //window.location.href = "ct-question-answer-p2h/create?action=edit";
    },

    copyData(row) {
      var params = this.$onRandom(row.m_p2h_question_id);
      this.$router.push(`ct-question-answer-p2h/create?action=copy&params=${params}`);
      //window.location.href = "ct-question-answer-p2h/create?action=edit";
    },

    detailData(row) {
      var params = this.$onRandom(row.m_p2h_question_id);
      this.$router.push(`ct-question-answer-p2h/create?action=detail&params=${params}`);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },
    sendOrder() { },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    cancelOrder() {

    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    acceptOrder(row) {
      this.transport_order_header_ids = [row.transport_order_header_id]
      this.showModalApprove = true;
    },

    rejectOrder(row) {
      this.transport_order_header_ids = [row.transport_order_header_id]
      this.showModalApprove = true;
    },


    downloadData() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate,)).format('YYYY-MM-DD'), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate,)).format('YYYY-MM-DD'),
      };

      var startDate = dataSend.start;
      var endDate = dataSend.end;
      var pick_plan = startDate + '~' + endDate;

      var dest_plan = '';
      if (this.serverParams.columnFilters.dest_plan != '') {
        dest_plan = this.$moment(this.serverParams.columnFilters.dest_plan).format("YYYY-MM-DD");
      }


      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + `control-tower/transport-order-header/p2h-checklist?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pick_plan=${pick_plan}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&dest_plan=${dest_plan}&pick_name=${this.serverParams.columnFilters.pick_name}&dest_name=${this.serverParams.columnFilters.dest_name}&type_truck=${this.serverParams.columnFilters.type_truck}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&load_id=${this.serverParams.columnFilters.load_id}&shipwith_ref=${this.serverParams.columnFilters.shipwith_ref}&branch_name=${this.serverParams.columnFilters.branch_name}&payable=${this.serverParams.columnFilters.payable}&job_external=${this.serverParams.columnFilters.job_external}&p2h_checklist_result=${this.serverParams.columnFilters.p2h_checklist_result}&p2h_approval=${this.serverParams.columnFilters.p2h_approval}&download=download`;

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_report_checklistp2h" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
          baseURI,
          {
            responseType: "blob",
          }
        )
        .then((response) => {

          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },


    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },



    updateFormatDate(date) {
      let date_format = this.$moment(date).format("dd mmm yyyy");
      return date_format;
    },



    viewData(row) {
      var params = this.$onRandom(row.transport_order_header_id);
      this.$root.$router.push({
        path: `/ct-orders/pod-form-view/` + params,
      })
      // var params = this.$onRandom(row.transport_order_header_id);
      // window.location.href = "/ct-orders/edit/" + params;
    },


    selectionChanged(ev) {

      this.rowsSelection = [];
      this.transport_order_header_ids = [];

      this.rowsSelection = ev.selectedRows;

      this.rowsSelection.forEach((item) => {

        this.transport_order_header_ids.push(item.transport_order_header_id);


      });






    },


    newData() {
      this.$router.push('ct-question-answer-p2h/create');
      //window.location.href = "ct-question-answer-p2h/create";
    },



    // load items is what brings back the rows from server
    loadItems() {
   

      //   var startDate= dataSend.start;
      //    var endDate= dataSend.end;
      //    var pick_plan=startDate+'~'+endDate;

      //    var dest_plan = '';
      //   if (this.serverParams.columnFilters.dest_plan != '') {
      //     dest_plan = this.$moment(this.serverParams.columnFilters.p2h_name).format("YYYY-MM-DD");
      //   }


      //let tanggal = this.filtertanggal.toISOString().split('T')[0]
      this.isLoading = true;
      const baseURI = this.$settings.endPointLincMobile + `web/m-p2h-question?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&p2h_name=${this.serverParams.columnFilters.p2h_name}&p2h_description=${this.serverParams.columnFilters.p2h_description}&deployment_date=${this.serverParams.columnFilters.deployment_date}&enabled=${this.serverParams.columnFilters.enabled}`;

      return this.$http
        .get(
          baseURI,
          // +
          // `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&company_name=${company_name}&transport_order_template_tonnage=${transport_order_template_tonnage}&transport_order_template_cubic=${transport_order_template_cubic}&transport_order_template_description=${transport_order_template_description}&order_status=${this.serverParams.columnFilters.order_status}&order_no=${this.serverParams.columnFilters.order_no}&postpone_time=${this.serverParams.columnFilters.postpone_time}&dest_name=${this.serverParams.columnFilters.dest_name}&order_date=${date_order}&pick_plan=${pick_plan}&dest_plan=${dest_plan}`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                //this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },


    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    success2(msg) {
      // let pesan="";
      // msg.forEach((item) => {
      //     pesan=pesan+"<p>* "+item+"</p>";
      // });

      this.$swal({
        icon: 'info',
        backdrop: true,
        title: "Information",
        html: msg,
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false
      })


    },

    loadingSubmiting() {

      this.$swal({
        icon: 'warning',
        backdrop: true,
        title: "Please wait",
        html: '<h2>SUBMITTING ORDER...</h2>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();
    this.loading();
    this.loadItems();


  },
};
</script>
<style scoped>
.blur-content {
  filter: blur(5px);
  pointer-events: none;
}

.card-body {
  padding: 5px 1.5rem 1rem;
}

.vgt-table th {
  text-align: left !important;
}

.toggleFilterClass {
  display: none !important;
}
</style>